import React from 'react';
import { useAuth } from '../../hooks/Auth';
import { useLanguage } from '../../hooks/Language';
import { useToast } from '../../hooks/Toast';
import { Button } from '../Button/styles';
import Whatsapp from '../Whatsapp';
import CopyToClipboard from '../CopyToClipboard';

// import { Container } from './styles';
interface VimeoProps {
  id: string;
  keyName?: string;
  time?: string;
  roomName?: string;
}

const ZoomContainer: React.FC<VimeoProps> = ({ id = '', roomName = '', keyName, time = '0' }) => {

  const { user} = useAuth();
  const {translate} = useLanguage();
  const {addToast} = useToast();




  return (
    <div style={{padding: '10px', textAlign: 'center', marginTop: '30px'}}>
      <h2>{translate('Instruções')}</h2><br/>
      <p style={{marginBottom: '20px'}}><div style={{marginBottom: '20px'}}>
      1. {translate('Copie o seu código de acesso.')}<br/>
2. {translate('Clique no botão "Acessar sala"')}<br/>
3. {translate('Cole o seu código de acesso no campo "Nome"')}

      
        <br/></div>
      <strong style={{background: 'rgba(150,100,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 'auto', padding: '10px'}}><span style={{marginRight: '15px'}}>{user.name} #{9100+parseInt(user.id,10)} </span><CopyToClipboard text={`${user.name} #${9100+parseInt(user.id,10)}`}/></strong> 
      </p>
     <a style={{marginBottom: '20px'}} href={`https://us02web.zoom.us/wc/join/${id}`} target="_BLANK"><button className="defaultButtonReverse" type="button">{translate('Acessar sala')}</button></a>
     <Whatsapp
                text={`${translate('Olá, estou tentando acessar a sala')} ${roomName}`}
                message={translate('Suporte Técnico')}
              />
    </div>
  );
};

export default ZoomContainer;
